module.exports = __webpack_public_path__ + "site/img/3d_expired.18af5131.png";